import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from './axios'
import VueAxios from 'vue-axios'
import VueLazyload from 'vue-lazyload'

// 引入iconf
import './assets/icon/iconfont.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import './plugins/element.js'
import utils from './plugins/utils.js'
import vuescroll from 'vuescroll';
import 'vuescroll/dist/vuescroll.css';
import VueClipboard from 'vue-clipboard2'

import { Upload ,Icon,Button } from 'ant-design-vue';

Vue.use(VueClipboard);
Vue.use(vuescroll);
Vue.use(Upload);
Vue.use(Icon);
Vue.use(Button);



Vue.config.productionTip = false
Vue.prototype.$baseUrl = process.env.BASE_URL
Vue.prototype.$utils = utils



Vue.use(VueAxios, axios)
Vue.use(VueAwesomeSwiper)

new Vue({
  router,
  store,
  render: h => h(App),
  mounted() {
    // document.dispatchEvent(new Event('render-event'));
  }
}).$mount('#app')
